// Cookie-Einstellungen: Shopify hängt an Richtlinien-Listen den Link #shopifyReshowConsentBanner an,
// der im eigenen Theme nichts auslöst. Er öffnet hier die Einstellungen des Shopify-Cookie-Banners.
// Blockiert der Browser das Banner (z. B. Werbeblocker), führt der Link zur Datenschutzerklärung.
document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href$="#shopifyReshowConsentBanner"]');
  if (!link) return;
  e.preventDefault();
  if (window.privacyBanner?.showPreferences) window.privacyBanner.showPreferences();
  else window.location.href = '/policies/privacy-policy';
});
